import {Connection} from "../connection/connection";

export interface Debt {
    id: number
	propertyId: number
	systemType: string
	type: string
	sum: number
	comment: string
    lastPaidMeterData: number
    connectionId: number
    electricityKwhRate: number
	createdAt: string
	updatedAt: string
}

export interface DebtsTableComponentProps {
    debts: Debt[],
    propertyId: number,
    recallData: () => void
    connections: Connection[] | null,
}

export interface AddDebtsModalComponentProps {
    propertyId: number,
    recallData: () => void
}

export interface AddDebtsFormFields {
    propertyId: number
	systemType: string
	type: string
	sum: string
	comment: string
}

export interface AddUpdateDebtsModalComponentProps {
    close: () => void,
    openCloseState: boolean
    debt: Debt,
    connections: Connection[] | null,
    recallData: () => void
    type: "add" | "edit"
}

export interface UpdateDebtFormFields {
    id: number
    propertyId: number
	systemType: string
	type: string
	sum: string
	comment: string
    lastPaidMeterData: string
    connectionId: number
    electricityKwhRate: string
}

export interface DebtsTableDropDownComponentProps {
    debt: Debt,
    openEditModal: (debt: Debt) => void,
    recallData: () => void,
    connections: Connection[] | null,
}

export const DebtsSystemTypes: { [key: string]: string } = {
    membershipFee: "Членский взнос",
    electricity: "Элекстричество",
    waterKey: "Ключь от скважены",
    other: "Другое",
}